import Rest from '../Rest'

export default class PronounTreatmentService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/pronoun_treatments'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }
}
